"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhysicsPredictionGameObject = void 0;
var realms_engine_1 = require("realms-engine");
var lodash_1 = __importDefault(require("lodash"));
var PhysicsPredictionGameObject = /** @class */ (function (_super) {
    __extends(PhysicsPredictionGameObject, _super);
    function PhysicsPredictionGameObject(masterState) {
        var _this = _super.call(this) || this;
        _this.masterState = masterState;
        _this.lastSlaveChanges = null;
        /**
         * Enables client side prediction
         */
        _this.enableClientSidePrediction = false;
        /**
         * Creates the corresponding shape object
         */
        _this.createShapeObject = function (shape) {
            switch (shape.shape.type) {
                case "box": {
                    return __assign(__assign({ shape: new realms_engine_1.CANNON.Box(new realms_engine_1.CANNON.Vec3(shape.shape.size.x, shape.shape.size.y, shape.shape.size.z)) }, (shape.position ? { position: shape.position } : {})), (shape.quaternion ? { quaternion: shape.quaternion } : {}));
                }
                case "plane": {
                    return __assign(__assign({ shape: new realms_engine_1.CANNON.Plane() }, (shape.position ? { position: shape.position } : {})), (shape.quaternion ? { quaternion: shape.quaternion } : {}));
                }
                case "sphere": {
                    return __assign(__assign({ shape: new realms_engine_1.CANNON.Sphere(shape.shape.radius) }, (shape.position ? { position: shape.position } : {})), (shape.quaternion ? { quaternion: shape.quaternion } : {}));
                }
                case "cylinder": {
                    return __assign(__assign({ shape: new realms_engine_1.CANNON.Cylinder(shape.shape.radiusTop, shape.shape.radiusBottom, shape.shape.height) }, (shape.position ? { position: shape.position } : {})), (shape.quaternion ? { quaternion: shape.quaternion } : {}));
                }
                case "heightfield": {
                    return __assign(__assign({ shape: new realms_engine_1.CANNON.Heightfield(shape.shape.data, shape.shape.options) }, (shape.position ? { position: shape.position } : {})), (shape.quaternion ? { quaternion: shape.quaternion } : {}));
                }
            }
        };
        _this.physicsObject = _this.addChild(new realms_engine_1.Physics3DBodyGameObject(new realms_engine_1.CANNON.Body(masterState.body), masterState.shapes.map(_this.createShapeObject)));
        return _this;
    }
    /**
     * Gets the id of the Physics GameObject
     */
    PhysicsPredictionGameObject.prototype.getPhysicsGameObjectId = function () {
        return this.masterState.physicsGameObjectId;
    };
    /**
     * Enabling prediction means that the state is no longer a 1 to 1 tracking
     * of the master state from the server, but that it supports client side prediction / updates
     * and will perform client side reconciliation
     */
    PhysicsPredictionGameObject.prototype.setEnableClientSidePrediction = function (enable) {
        this.enableClientSidePrediction = enable;
        if (!this.enableClientSidePrediction && this.lastSlaveChanges) {
            // Update if enabled sync again
            this.onSlaveChanges(this.lastSlaveChanges.changes, this.lastSlaveChanges.newState);
        }
    };
    /**
     * Handles slave changes
     */
    PhysicsPredictionGameObject.prototype.onSlaveChanges = function (changes, newState) {
        var e_1, _a;
        this.lastSlaveChanges = {
            changes: changes,
            newState: newState,
        };
        this.masterState = newState;
        // Ignore syncing
        if (this.enableClientSidePrediction) {
            return;
        }
        if (changes.shapes && !lodash_1.default.isEqual(changes.shapes, this.masterState.shapes)) {
            this.physicsObject.setShapes(newState.shapes.map(this.createShapeObject));
        }
        if (changes.body) {
            try {
                for (var _b = __values(Object.entries(changes.body)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), change = _d[0], value = _d[1];
                    this.physicsObject.getCANNONBody()[change] = value;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (changes.position !== undefined) {
            this.physicsObject.setPosition(newState.position);
        }
        if (changes.quaternion !== undefined) {
            this.physicsObject.setQuaternion(newState.quaternion);
        }
    };
    PhysicsPredictionGameObject.prototype.getQuaternion = function () {
        return this.physicsObject.getQuaternion();
    };
    PhysicsPredictionGameObject.prototype.setQuaternion = function (q) {
        this.physicsObject.setQuaternion(q);
    };
    PhysicsPredictionGameObject.prototype.getPosition = function () {
        return this.physicsObject.getPosition();
    };
    PhysicsPredictionGameObject.prototype.setPosition = function (position) {
        this.physicsObject.setPosition(position);
    };
    return PhysicsPredictionGameObject;
}(realms_engine_1.GameObject));
exports.PhysicsPredictionGameObject = PhysicsPredictionGameObject;
